import { Monitor, Moon, Sun } from 'lucide-react'


import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from './dropdown-menu'
import { Button } from './button'
import { DesktopIcon } from '@phosphor-icons/react'

/**
 * Shadcn default: expects theme and setTheme as props.
 * Accepts className for custom button styling.
 */
export function DarkModeToggle({
  theme = 'system',
  setTheme = () => {},
  className,
}) {
  const active =
    theme === 'light' ? 'light' : theme === 'dark' ? 'dark' : 'system'
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className={className}>
          {theme === 'dark' ? (
            <Moon className="size-[1.1875em]" />
          ) : theme === 'light' ? (
            <Sun className="size-[1.1875em]" />
          ) : (
            <Monitor className="size-[1.1875em]" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuCheckboxItem
        checked={active === 'light'}
          onClick={() => setTheme('light')}
        >
          <Sun className="mr-2 size-4" />
          <span>Light</span>
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
        checked={active === 'dark'}
          onClick={() => setTheme('dark')}
        >
          <Moon className="mr-2 size-4" />
          <span>Dark</span>
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={active === 'system'}
          onClick={() => setTheme('system')}
        >
          <DesktopIcon />
          <span>System</span>
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
